import React, {Fragment, useEffect, useState} from 'react';

// This module is to be used in School360 and we need to allow for the imported functios to be loaded from different locations
// so the commonExports module can be modified for the other project to allow loading from alternate locations for now
import { ModalButton, ModalContentWrapper, SpinnerDiv, getPupilObservations, getDataFromResponse, getChildDataWithDetails, generateLearningJournalFromData } from "./commonExports";

import {LearningJournalModalModes} from "./useModalLearningJournal";

import './ModalLearningJournal.scss' ;
import useLoadingDialog from "./useLoadingDialog";

const ModalLearningJournal = ({mode, flags, alds, coels, child_id, school360_school_id, learning_journal_ald, date_from, date_to, onSaveCompleted}) =>
{
    const initialLoadingState = true ; // [ LearningJournalModalModes.SELECT ].includes ( mode ) ;

    const [ data, setData ] = useState ( { loading: initialLoadingState, school360_school_id: null, observations: [], childData: []})

    const { setProgress, renderProgressBar, getRemainingTime, isComplete } = useLoadingDialog() ;

    const [ loadingMode, setLoadingMode ] = useState ( mode ) ;

    useEffect(() =>
    {
        const params = {
            date_from: date_from,
            date_to: date_to,
            flags: flags,
            alds: alds,
            coels: coels,
        }
        if ( mode === LearningJournalModalModes.SELECT )
        {
            getPupilObservations(child_id, school360_school_id, date_from, date_to, params, (response) =>
            {
                const observations = getDataFromResponse(response);

                getChildDataWithDetails(child_id, [], (response) =>
                {
                    const childData = getDataFromResponse(response);

                    setData ({ loading: false, school360_school_id: school360_school_id, observations: observations, childData: childData[0] });
                });
            });
        }
    },[]);

    const onUpdateProgress = ( params ) =>
    {
        setProgress( params ) ;
    }

    const onClickGenerate = () =>
    {
        setLoadingMode( LearningJournalModalModes.LOADING );

        generateLearningJournalFromData({observations:data.observations, school360_school_id: data.school360_school_id, childData: data.childData, updateProgressFn: onUpdateProgress, flags: flags})
            /* generateLearningJournal( { child_id: child_id, firstname: firstname,
            surname: surname, school360_school_id: school360_school_id, learning_journal_ald: 'all',
            date_from: date_from, date_to: date_to, updateProgressFn: onUpdateProgress }) ; */
    }

    const onClickCancel = () =>
    {
        onSaveCompleted('cancel') ;
    }

    const modalText = (mode) =>
    {
        switch ( mode )
        {
            case LearningJournalModalModes.SELECT:

                return (
                <Fragment>
                    <h2>Generate Learning Journal</h2>
                    <p>Are you sure you want to generate the child's learning journal?</p>
                    <p>This may take a few minutes.</p>

                    <div className='modal-button-row'>
                        <ModalButton onClick={onClickCancel} text='Cancel' iconClass='et-arrow-bold-left' additionalClass='btn-gray' />
                        <ModalButton onClick={() => onClickGenerate()} text='Generate' iconClass='et-arrow-bold-right' additionalClass='btn-primary-lj'/>
                    </div>

                </Fragment>
            );

            default:
                return <div>Invalid mode : {mode} </div>
        }
    }

    const modalTextNoData = () =>
    {
        return (
            <Fragment>
                <h2>Generate Learning Journal</h2>
                <p>There are no observations for the selected period</p>

                <div className='modal-button-row'>
                    <ModalButton onClick={onClickCancel} text='Close' iconClass='et-arrow-bold-left' additionalClass='btn-gray'/>
                </div>

            </Fragment>
        );

    }

    const onClickClose = () =>
    {
        onSaveCompleted ( 'done' ) ;
    }

    const loadingPage = () =>
    {
        return (
            <div className='learning-journal-modal-progress'>
                <h2>Generating the journal.... please wait.</h2>
                <div className='journal-bar'>
                    { renderProgressBar() }
                </div>
                <div className='journal-time-remaining'>
                    { getRemainingTime() }
                </div>
                { isComplete && <div className='modal-button-row'>
                    <ModalButton onClick={() => onClickClose()} text='Close' iconClass='et-arrow-bold-right'/>
                </div> }
            </div>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            { data.loading === false &&
                <div>
                    { loadingMode === LearningJournalModalModes.SELECT && data.observations.length !== 0 && modalText(loadingMode) }
                    { loadingMode === LearningJournalModalModes.SELECT && data.observations.length === 0 && modalTextNoData() }
                    { loadingMode === LearningJournalModalModes.LOADING && loadingPage() }
                </div> }
            { data.loading === true && <SpinnerDiv/> }
        </ModalContentWrapper>
    );
}

export default ModalLearningJournal;